jQuery(document).ready(function () {

    // Initialize Tiny Slider
    jQuery(".tiny-slider.tiny-slider-carousel").each(function () {
        var sliderId = jQuery(this).data('slider');
        var currentSlider = jQuery('.tiny-slider.tiny-slider-carousel.' + sliderId).parents('.carousel-container');
        var carouselSlider = tns({
            container: '.tiny-slider.tiny-slider-carousel.' + sliderId,
            items: 1,
            slideBy: 'page',
            autoplay: true,
            mouseDrag: true,
            controls: false,
            nav: true,
            loop: false,
            autoHeight: true,
            navContainer: "#carousel-pagination",
            responsive: {
                1400: {
                    items: 1.15
                }
            }
        });

        jQuery(window).resize(function () {
            carouselSlider.destroy();
            carouselSlider = carouselSlider.rebuild();
        });


    });

    jQuery(window).resize();

});